// extracted by mini-css-extract-plugin
export default {"greeting":"Connect_greeting__Z82Jp","reach":"Connect_reach__WG8Xx"};